export default "__VITE_ASSET__DVTkB4Sb__"